
import { postNewOneTimeNoRideForm } from '../api.js'

import notifications from '../notifications.js'


function _postNewOneTimeNoRideForm(content) {
  let promise = postNewOneTimeNoRideForm(content)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data}`, error)
    })

  return promise
}

function _canSubmitForm(user) {
  if (user === undefined) {
    return false
  }

  return user.can('submit_one_time_no_ride')
}

function _canViewInternalCstData(user) {
  if (user === undefined) {
    return false
  }

  return user.can('view_internal_cst_data')
}

function _init() {
  // do nothing
}

_init()

export default {
  postNewOneTimeNoRideForm: _postNewOneTimeNoRideForm,
  canSubmitForm: _canSubmitForm,
  canViewInternalCstData: _canViewInternalCstData,
}
